import API from "..";

export default class WorkRequestTypeSiteMapping {

  constructor({
    siteName,
    workRequestTypeName
  }) 
    
  {
    this.siteName = siteName;
    this.workRequestTypeName = workRequestTypeName;
  }

  static async getAll() {
    const api = await API();
    const { data } = await api.get(`/workRequestTypeSiteMapping`);
    if (data.result) {
        return data.result.map((d) => new WorkRequestTypeSiteMapping(d));
    }
    else {
        return [];
    }
  }
}
